import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert } from '../../CommonUtils/SweetAlerts';
import { getYearsDynamicBasedOnInput } from '../../CommonUtils/CommonServices';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';

export default function AffiliationIGRSdocuments() {
    const [submittedData, setsubmittedData] = useState();
    const [hidetable, sethidetable] = useState(false);
    const DB_PASSWORD = "HiEdu@23#"

    const afflIgrsValidations = Yup.object().shape({

        srcode: Yup.string().required(ERROR_MSG).nullable(),
        docno: Yup.string().required(ERROR_MSG).nullable(),
        ryear: Yup.string().required(ERROR_MSG).nullable(),

    });
    const AfflIGRFFormik = useFormik({
        initialValues: {
            srcode: "",
            docno: "",
            ryear: "",
            bookno: "1",
            username: "higher_education_igrs",
            password: DB_PASSWORD
        },
        enableReinitialize: true,
        validationSchema: afflIgrsValidations,
        onSubmit: (values) => {
            // let url = 'https://sbiepaypayment.apcfss.in/SbiEpayPayment/igrsservice'
            let url = `${config.url.API_URL}igrsservice`;


            CommonAxiosPost(url, values).then((res) => {
                if (res?.data !== undefined) {
                    if (res?.data?.SCODE !== "3") {
                        setsubmittedData(res?.data)
                        sethidetable(true)
                    }
                    else {
                        setsubmittedData("***No Data Found***")
                    }
                }
                else {
                    failureAlert("Internal server Problem")
                }
            })

        }

    })


    const [SroList, setSroList] = useState([]);
    function GetSroDist() {
        let url = config.url.API_URL + `getSroList`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setSroList(res?.data?.getSroList)
            } else {
                setSroList([])

            }
        })
    }
    useEffect(() => {
        GetSroDist();
    }, [])

    const secureRandom = (min, max) => {
        const range = max - min + 1;
        const buffer = new Uint32Array(1);
        window.crypto.getRandomValues(buffer); // Get cryptographically secure random values
        return min + (buffer[0] % range);
    };

    // Example usage:
    const secureRandomValue = secureRandom(1, 100); // Generates a secure random number between 1 and 100

    return (
        <>
            <CommonFormHeading heading="IGRS documents" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={AfflIGRFFormik}>
                    <Form onChange={AfflIGRFFormik.handleChange} onSubmit={AfflIGRFFormik.handleSubmit} className="affl-form" >

                        <bie.Row className="px-2 pt-3 mb-5">
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                    {/* <bie.InputGroup className="mb-4p5"> */}
                                    <label className="mb-1 field-mandatory">SRO Name:</label>
                                    <Field as="select" name="srcode" className="form-control mb-2" onChange={(e) => {
                                        sethidetable(false);
                                        setsubmittedData('')
                                    }}>
                                        <option value=''>---select---</option>
                                        {SroList && SroList.map((srodata, i) => (
                                            <option value={srodata?.sro_code}>{srodata?.sro_name}</option>
                                        ))}
                                    </Field>

                                    <ErrorMessage name="srcode" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                    {/* <bie.InputGroup className="mb-4p5"> */}
                                    <label className="label-text-style"> <b className="field-mandatory">Registration Year</b> </label>
                                    <Field as="select" name="ryear" className="form-control mb-2" onChange={(e) => {
                                        sethidetable(false);
                                        setsubmittedData('')
                                    }}>

                                        <option value=''>---Select---</option>
                                        {getYearsDynamicBasedOnInput(1970).map(year => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </Field>

                                    <ErrorMessage name="ryear" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                    {/* <bie.InputGroup className="mb-4p5"> */}
                                    <label className="label-text-style"> <b className="field-mandatory">Doc No</b> </label>
                                    <Field type="text" name="docno" className="form-control mb-2" />

                                    <ErrorMessage name="docno" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={2} xxl={2} className='mt-4  text-start'>
                                    <button type='submit' className='btn btn-primary mb-4 '>Get Data</button>
                                </bie.Col>
                            </bie.Row>


                            {hidetable === true && submittedData !== undefined && submittedData !== "***No Data Found***" ? (<>
                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4">
                                    <h1 className="m-0 p-0 pb-2">  Document Details</h1></div>
                                <div className="table-responsive">
                                    <center>
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true">

                                            <tbody>
                                                <tr><td>Registartion Year			</td>
                                                    <td>{submittedData?.REGYEAR}</td>
                                                </tr>
                                                <tr>
                                                    <td>Registartion Document No		</td>
                                                    <td> {submittedData?.REGDOCNO}</td>
                                                </tr>
                                                <tr>

                                                    <td>Registartion Date	</td>
                                                    <td> {submittedData?.REGDATE}</td>
                                                </tr>
                                                <tr>
                                                    <td>Type Of Document	</td>
                                                    <td>{submittedData?.DOCTYPE}</td>
                                                </tr>
                                                <tr>
                                                    <td>Registartion Document	</td>

                                                    <td>

                                                        {
                                                            submittedData?.REGDOCUMENTLINK ? (
                                                                submittedData?.DOCTYPE === "pdf" ? (
                                                                    <a
                                                                        href={`${submittedData?.REGDOCUMENTLINK}`}
                                                                        className="text-primary"
                                                                        download="document.pdf"
                                                                    >
                                                                        Download PDF
                                                                    </a>
                                                                ) : (
                                                                    <a
                                                                        href={`data:image/tiff;base64,${submittedData?.REGDOCUMENTLINK}`}
                                                                        id="base64image"
                                                                        target="_new"
                                                                        download="image.tiff"
                                                                    >
                                                                        View (Download)
                                                                    </a>
                                                                )
                                                            ) : (
                                                                <span>-</span>
                                                            )
                                                        }

                                                    </td>


                                                </tr>


                                            </tbody>
                                        </table>
                                    </center>
                                </div>
                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4">
                                    <h1 className="m-0 p-0 pb-2"> Schedule Details</h1></div>
                                <div className="table-responsive">
                                    <center>
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true">

                                            <tbody>

                                                <tr>
                                                    <td>Survey No		</td>
                                                    <td> {submittedData?.SURVEYNOS}</td>
                                                    <td>Schedule Extent		</td>
                                                    <td>{submittedData?.SCHEDEXTENT}</td>
                                                    <td>Schedule Unit		</td>
                                                    <td>{submittedData?.SCHEDUNIT}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </center>
                                </div>
                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4">
                                    <h1 className="m-0 p-0 pb-2"> Party Details</h1></div>
                                <div className="table-responsive">
                                    <center>
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true" >

                                            <tbody>

                                                <tr>
                                                    <td>Party Name	</td>
                                                    <td> {submittedData?.PARTYNAME}</td>

                                                </tr>

                                            </tbody>
                                        </table>
                                    </center>
                                </div>
                            </>) : (<b style={{ color: "red", fontSize: "15px", textAlign: "center" }}>{submittedData} </b>)}

                        </bie.Row>
                    </Form>
                </FormikProvider >
            </bie.Container >



        </>
    )
}
